import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
const httpOptions = {
  headers: new HttpHeaders({
   "enctype": "multipart/form-data",
  })
};
const AUTH_API = environment.apiUrl;
@Injectable({
  providedIn: 'root'
})
export class ImproveService {
  _improveComponent: any = {};
  _improvePiFilterObj: any = {};

  constructor(private http: HttpClient) { }

  GetImproveData(obj: any) {
    return this.http.post<any>(AUTH_API + `/improve/GetImproveData`,obj);
  }

  InsertUpdateImproveData(obj: any) {
    return this.http.post<any>(AUTH_API + '/improve/InsertUpdateImproveData', obj);
  }

  GetImproveFacility(roleName:any,UID:any,obj: any) {
    return this.http.post(AUTH_API + `/improve/GetImproveFacility?roleName=${roleName}&userId=${UID}`, obj);
  }

  GetImproveRapidi(obj: any, UID: string, roleName: string) {
    return this.http.post(AUTH_API + `/improve/GetImproveRapidi?roleName=${roleName}&userId=${UID}`, obj);
  }

  GetFacilityContact(facilityID: any, obj: any) {
    return this.http.post(AUTH_API + `/facilities/GetFacilityContact?fac_key=${facilityID}`, obj);
  }

  SendEmailImproveFacility(obj: any){
    return this.http.post<any>(AUTH_API + '/improve/SendEmailImproveFacility', obj);
  }

  GetEmailImproveFacility(model: any){
    return this.http.post(AUTH_API + `/improve/GetEmailImproveFacility`, model);
  }

  GetUserByFacility(model: any){
    return this.http.post(AUTH_API + `/improve/GetUserByFacility`, model);
  }
  GetPieChartData(roleName:any,UID:any,obj: any) {
    return this.http.post(AUTH_API + `/improve/GetPieChartData?roleName=${roleName}&userId=${UID}`, obj)
  }
}
